import dayjs from 'dayjs';
import { jt, t } from 'ttag';

/**
 * Builds the maintenance notice for a window given in any offset, expressed in the viewer's local time, as plain text and as content with the window emphasized. Formats the start as date and time, the end as time only when it falls on the same local day or as full date and time otherwise, and labels both with a GMT offset taken from the start, adding minutes only for half-hour zones.
 *
 * @param startTime - Maintenance start as ISO 8601 with an explicit offset or Z.
 * @param endTime - Maintenance end as ISO 8601 with an explicit offset or Z.
 * @returns The translated notice as `text`, and as `content` with the window wrapped in `<strong>`.
 */
export const getMaintenanceMessage = (startTime: string, endTime: string) => {
  const start = dayjs(startTime);
  const end = dayjs(endTime);
  const dateTimeFormat = 'MMM D, YYYY [at] h:mm A';
  const offset = start.utcOffset();
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const gmtOffset = `GMT${offset < 0 ? '-' : '+'}${offsetHours}${
    offsetMinutes ? `:${String(offsetMinutes).padStart(2, '0')}` : ''
  }`;
  const startText = start.format(dateTimeFormat);
  const endText = end.format(end.isSame(start, 'day') ? 'h:mm A' : dateTimeFormat);
  const windowText = t`${startText} to ${endText} (${gmtOffset})`;
  const windowElement = <strong key="window">{windowText}</strong>;
  return {
    text: t`The portal will be undergoing maintenance from ${windowText}. During this time, the portal will be unavailable.`,
    content: jt`The portal will be undergoing maintenance from ${windowElement}. During this time, the portal will be unavailable.`,
  };
};
